export type InventoryLocation = {
	branch?: {
		name: string,
	},
	name: string,
}

function render( inventoryLocation: InventoryLocation ) {
	return inventoryLocation.name
}

export default {
	field: 'inventoryLocation',
	name: 'Store',
	render,
}
